<template>
  <div class="home">
    <router-link class="introduce" to="/introduce">
      点击了解
      <van-icon name="arrow" />
    </router-link>
    <van-image width="100%" height="100%" :src="imgUrl" />
    <div class="contianer">
      <div class="cardContainer">
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgGreen" />
          </van-col>
          <van-col span="22">
            <div class="border">
              <van-field
                v-model="$store.state.userBusRoute.start"
                :placeholder="inputPlaceholder"
                readonly="readonly"
                @click="inputStartFun('start')"
              />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgRed" />
          </van-col>
          <van-col span="22">
            <div class="border">
              <van-field
                v-model="$store.state.userBusRoute.end"
                placeholder="请输入目的地"
                readonly="readonly"
                @click="inputStartFun('end')"
              />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgUser" />
          </van-col>
          <van-col span="22">
            <div class="border borderArrow" name="arrow" @click="peopleCountingShow = true">
              <!--  v-model="userBusRoute.peopleCounting" -->
              <van-field
                v-model="$store.state.userBusRoute.peopleText"
                placeholder="请输入乘车人数"
                readonly="readonly"
              />
            </div>
          </van-col>
        </van-row>
        <van-row class="flex">
          <van-col span="2">
            <van-image width="12" height="12" :src="imgTime" />
          </van-col>
          <van-col span="22">
            <div class="border borderArrow" @click="timeSelectFun">
              <van-field
                v-model="$store.state.userBusRoute.time"
                placeholder="请选择用车时间段"
                readonly="readonly"
              />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 显示车辆 -->
    <div class="containerTwo" v-show="carCardShow">
      <div class="cardContainer">
        <p class="carTitle">城际拼车</p>
        <van-image width="200" height="76" :src="imgCar" />
        <p class="carMoney">
          <span>¥&nbsp;</span>
          {{money}}
        </p>

        <van-button class="danger" @click="taxiService">确认叫车</van-button>
      </div>
    </div>
    <div class="advertisingContainer">
      <div class="imgAdvertising1">
        <van-image width="100%" height="100%" :src="imgAdvertising2" />
      </div>
      <div class="imgAdvertising2">
        <van-image width="100%" height="100%" :src="imgAdvertising1" />
      </div>
    </div>

    <van-action-sheet v-model="peopleCountingShow" title="七座商务车-选择乘车人数">
      <div class="peopleContent">
        <van-row>
          <van-col span="18" class="peopleTitle">若有携带婴儿也需算入乘客人数</van-col>           
        </van-row>

        <van-row class="peopleCountinContainer">
          <van-col span="6">
            <span class="person" @click="peopleFun('1人')">1人</span>
          </van-col>
          <van-col span="6">
            <span class="person" @click="peopleFun('2人')">2人</span>
          </van-col>
          <van-col span="6">
            <span class="person" @click="peopleFun('3人')">3人</span>
          </van-col>
          <van-col span="6">
            <span class="person" @click="peopleFun('4人')">4人</span>
          </van-col>
           <van-col span="6">
            <span class="person" @click="peopleFun('5人')">5人</span>
          </van-col>
           <van-col span="6">
            <span class="person" @click="peopleFun('6人')">包车(6人)</span>
          </van-col>
        </van-row>
      </div>
    </van-action-sheet>
    <!-- 时间控件 -->
    <Time
      :plusMinutes="plusMinutes"
      :TimeControlShow="TimeShow"
      @childTimeFun="fatherTime"
      @childTimeCancel="fatherTimeCance"
    />
    <!-- 登录 -->
    <Login :loginShow="FatherLoginShow" @close="fatherLogin" />
    <!-- 定位 -->
    <div id="mapContainer" style="display:none"></div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import Time from "@/components/Time/index.vue";
import Login from "./components/login.vue";
import { decodeTokenFun, UserIslogin } from "@/api/login.js";
import { getToken, setToken, setCompanyId } from "@/utils/auth.js";
import { splitUrl } from "@/utils/public.js";
import AMap from "AMap";
import {
  carHailingFun,
  pathPrice,
  companyIdFun,
  selectOrderFun,
} from "@/api/home.js";
export default {
  data() {
    return {
      imgUrl: require("../../assets/home/index-banner.png"),
      imgRed: require("../../assets/home/yuan-red.png"),
      imgGreen: require("../../assets/home/yuan-green.png"),
      imgUser: require("../../assets/home/user.png"),
      imgTime: require("../../assets/home/time.png"),
      imgCar: require("../../assets/home/car1.png"),
      imgAdvertising1: require("../../assets/home/advertising-1.png"),
      imgAdvertising2: require("../../assets/home/advertising-2.png"),
      inputPlaceholder: "请输入上车点",
      //车辆价格卡片显示状态
      carCardShow: false,
      //后台返回订单的参数要叫单时传递给后端
      lineSubId: "",
      //拼车价格
      money: 0,
      //乘客数据选择
      peopleCountingShow: false,
      TimeShow: false,
      FatherLoginShow: false, //登录页面是否显示
      map: "", //地图
    };
  },
  components: {
    Time,
    Login,
  },
  created() {
	  
	let tickets = splitUrl("ticket"); 
	console.log('tickets', tickets);
	
	let that = this;
	if(tickets) {
		let ticket = tickets[2].replace('%3F', '');
		console.log('ticket', ticket);
		setToken('bearer token-' + ticket);
		UserIslogin().then((res) => {
	    let result = res.data;
		console.log('res', res);
		console.log('result', result);
        if (result.code === "0") {
          setToken('bearer ' + result.data.accessToken);
		 that.queryOrder();
        }
      });
	} else {
		that.queryOrder();
	}
	  
    //获取运力公司
    let urlArray = splitUrl("companyId");
    if (urlArray) {
      this.$store.state.userBusRoute.companyId = urlArray[2];
      setCompanyId(urlArray[2]);
      companyIdFun(urlArray[2]).then((res) => {
        if (res.data.code === "-1") {
          Dialog.alert({
            title: "提示",
            message: "运力公司不存在无法下单",
          });
        }
      });
    }
    //司机编号
    let driverId =  splitUrl('driverId')
    if(driverId){
       this.$store.state.userBusRoute.driverId = driverId[2];
    }
	let did = this.$store.state.userBusRoute.driverId;
	if(did){
       this.plusMinutes = 0;
	}
    //从app跳转过来带定位（解决h5定位功能在app内太）
    let lng = splitUrl("lng");
    let lat = splitUrl("lat");
    
    if (lng && lat) {
      this.$store.state.userBusRoute.startLon = lng[2];
      this.$store.state.userBusRoute.startLat = lat[2];
      this.$store.state.TAG = 'IsAppPosition'
      this.$store.state.userBusRoute.receiveLon = lng[2];
      this.$store.state.userBusRoute.receiveLat = lat[2]
    }

    //从app跳转过来带登录token
    let decode = splitUrl("authorization");
    if (decode) {
      decodeTokenFun(decode[2]).then((res) => {
        let result = res.data;
        if (result.code === "0") {
          let authorizations = "bearer" + " "  + result.data;
          setToken(authorizations);
        }
      });
    }
    
  },
  mounted() {

    this.cardShowFun();
    //app没有传递过来经伪度时用h5定位
    if (
      !this.$store.state.userBusRoute.startLat &&
      !this.$store.state.userBusRoute.startLon
    ) {
      this.map = new AMap.Map("mapContainer", {
        resizeEnable: true,
      });

      this.geolocationFun();
    } else {
      //从app跳转过来，判断用户是否用app内定位还是自己搜索定位
      if(this.$store.state.TAG !== 'IsAppPosition'){
          return
      }
      //app传递过来经伪度时进行逆向地理编码方法
      let self = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder();
        let lng = parseFloat(self.$store.state.userBusRoute.startLon);
        let lat = parseFloat(self.$store.state.userBusRoute.startLat);
        let lnglat = [lng, lat];
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            //定位起点名字太长，截取字符串
            let data = result.regeocode;
            let position = "";
            let positionText =
              data.addressComponent.province +
              data.addressComponent.city +
              data.addressComponent.district +
              data.addressComponent.township;
            let formattedAddress = data.formattedAddress;
            if (formattedAddress.indexOf(positionText) !== -1) {
              position = formattedAddress.replace(positionText, "");
            } else {
              position = data.formattedAddress;
            }
            // 上车起点
            self.$store.state.userBusRoute.start = position;
            self.$store.state.userBusRoute.startCity =
              data.addressComponent.city;
			console.log('startAdcode2', data.addressComponent.adcode);
            self.$store.state.userBusRoute.startAdcode =
              data.addressComponent.adcode;
            //当前位置
            self.$store.state.userBusRoute.receiveAddress = position
            self.$store.commit("UpdataStart", self.$store.state.userBusRoute);
          }
        });
      });
    }
  },
  methods: {
	  isWexin() {
		let isWechat = false;
		var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
		if (ua.match(/MicroMessenger/i) == "micromessenger") {
				isWechat = true;
		}
		return isWechat;
	  },
	queryOrder() {
		//查询订单
		if (getToken()) {
		  selectOrderFun().then((res) => {
		    let result = res.data.data;
		    // if(!result){
		    //   return
		    // }
		    if (res.data.code === "0") {
				
			 let self = this;
			 
			 let isWechat = self.isWexin();
			 
			 let isWxapp = false;
			 if(isWechat && wx.miniProgram) {
			 	  wx.miniProgram.getEnv(function (res) { //getEnv获取环境
			 		if (res.miniprogram) {
			 			isWxapp = true;
			 			if (result.status === 0) {
							self.$router.push({ path: "/orderReceiving" });
						} else if (result.status >= 1 || result.status < 5) {
							self.$router.push({ path: "/driver/orderReceiving" });
						}
			 			return;
			 		} 
			 	  })
			 	  return;
			 } 	
			 
			 if(isWxapp) {
				return;
			 }
				
		      if (result.status === 0) {
		        Dialog.alert({
		          title: "提示",
		          message: "你发送了一个城际订单请前去查看",
		        }).then(() => {
		          this.$router.push({ path: "/orderReceiving" });
		        });
		        //
		      } else if (result.status >= 1 || result.status < 5) {
		        Dialog.confirm({
		          title: "提示",
		          message: "您有一个未完成的订单就请前去查看",
		        }).then(() => {
		          this.$router.push({ path: "/driver/orderReceiving" });
		        });
		      }
		    }
		  });
		}
	},
    //选择人数
    peopleFun(val) {
      if(val === '6人'){
         this.$store.state.userBusRoute.peopleText = '包车'  
      }else{
         this.$store.state.userBusRoute.peopleText = val
      }      
      this.$store.state.userBusRoute.peopleCounting = val;
      this.$store.commit("UpdataStart", this.$store.state.userBusRoute);
      this.peopleCountingShow = false;
      this.cardShowFun();
    },
    timeSelectFun() {
      this.TimeShow = true;
    },
    //监听时间子组件
    fatherTime(value) {
      console.log('timeValue', value);
      this.$store.state.userBusRoute.time = `${value.dataText} ${value.hours}:${value.minutes} - ${value.endHour}`;
      this.$store.state.userBusRoute.timeStart = `${value.year}/${value.month}/${value.days} ${value.hours}:${value.minutes}`;
      this.$store.state.userBusRoute.timeEnd = `${value.year}/${value.month}/${value.days} ${value.endHour}`;

      this.$store.commit("UpdataStart", this.$store.state.userBusRoute);
      this.TimeShow = value.state;
    },
    //监听时间子组件取消
    fatherTimeCance(value) {
      this.TimeShow = value;
    },
    //确定叫车
    taxiService() {
      //本地存在cookies就认为是登录了，如果没有就进入登录
      if (getToken()){
        let people;
        if (this.$store.state.userBusRoute.peopleCounting) {
          people = parseInt(
            this.$store.state.userBusRoute.peopleCounting.charAt(0)
          );
        }
        var userObj = {
          companyId: this.$store.state.userBusRoute.companyId, //运力公司
          driverId:this.$store.state.userBusRoute.driverId,
          startAddress: this.$store.state.userBusRoute.start,
          startCode: parseInt(this.$store.state.userBusRoute.startAdcode),
          startLat: this.$store.state.userBusRoute.startLat,
          startLon: this.$store.state.userBusRoute.startLon,

          endAddress: this.$store.state.userBusRoute.end,
          endCode: parseInt(this.$store.state.userBusRoute.endAdcode),
          endLat: this.$store.state.userBusRoute.endLat,
          endLon: this.$store.state.userBusRoute.endLon,

          receiveAddress: this.$store.state.userBusRoute.receiveAddress,
          receiveLat: this.$store.state.userBusRoute.receiveLat,
          receiveLon: this.$store.state.userBusRoute.receiveLon,

          startDate: this.$store.state.userBusRoute.timeStart,
          endDate: this.$store.state.userBusRoute.timeEnd,

          number: people,

          lineSubId: this.lineSubId,
        };
        if (!userObj.startDate && !userObj.endDate) {
          return Toast("请选择用车时间段");
        }

        //用户确认叫车
        carHailingFun(userObj).then((res) => {
          console.log("用户确认叫车", res);
          let result = res.data;
          switch (result.code) {
            case "0": //发单成功（司机未接单）
              this.$router.push({ path: "/orderReceiving" });
              break;
            case "0000": //未登录
              this.FatherLoginShow = true;
              break;
            case "1111": //您有未完成的城际订单，不能再次发单
              Dialog.confirm({
                title: "提示",
                message: result.msg,
              }).then(() => {
                if (result.data.status === 1) {
                  //司机接单
                  this.$router.push({ path: "/driver/orderReceiving" });
                } else if (result.data.status === 0) {
                  //没有接单
                  this.$router.push({ path: "/orderReceiving" });
                } else {
                  //司机接单（去接乘客/进行中）
                  this.$router.push({ path: "/driver/orderReceiving" });
                }
              });
              break;
            default:
              Dialog.alert({
                title: "提示",
                message: result.msg,
              }).then(() => {
                if (result.code === "-1" && result.msg === "乘客不存在") {
                  this.FatherLoginShow = true;
                }
              });
          }
        });
      } else {
        this.FatherLoginShow = true;
      }
    },

    fatherLogin(value) {
      this.FatherLoginShow = value;
    },
    //起点
    inputStartFun(value) {
      /**
       * 路径跳转判断是起点还是终点传递到搜索页面判断是要搜索那个值
       * */
      this.$router.push({
        path: "/location",
        query: { inputState: value },
      });
    },
    //判断用户所有数据都有时显示车辆信息
    cardShowFun() {
      if (
        this.$store.state.userBusRoute.start !== null &&
        this.$store.state.userBusRoute.end !== null &&
        this.$store.state.userBusRoute.peopleCounting !== null
        // &&this.$store.state.userBusRoute.time !== ""
      ) {
        let people;
        if (this.$store.state.userBusRoute.peopleCounting) {
          people = parseInt(
            this.$store.state.userBusRoute.peopleCounting.charAt(0)
          );
        }
        var userObj = {
          companyId: this.$store.state.userBusRoute.companyId,

          startCode: parseInt(this.$store.state.userBusRoute.startAdcode),
          startLat: this.$store.state.userBusRoute.startLat,
          startLon: this.$store.state.userBusRoute.startLon,

          endCode: parseInt(this.$store.state.userBusRoute.endAdcode),
          endLat: this.$store.state.userBusRoute.endLat,
          endLon: this.$store.state.userBusRoute.endLon,

          number: people,
        };
        pathPrice(userObj).then((res) => {
          let result = res.data;
          if (result.code === "0") {
            this.carCardShow = true;
            this.money = result.data.money;
            this.lineSubId = result.data.lineSubId;
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.msg,
            });
          }
          //控制是否显示车辆
          // this.carCardShow = true;
        });
      }
    },
    //定位
    geolocationFun() {
      let self = this;
      self.inputPlaceholder = "正在定位..";
      AMap.plugin("AMap.Geolocation", function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          showButton: false,
          showMarker: false,
        });
        self.map.addControl(geolocation);
        geolocation.getCurrentPosition(function (status, result) {
          if (status == "complete") {
            self.onComplete(result);
          } else {
            self.onError(result);
          }
        });
      });
    },
    //定位成功解析结束
    onComplete(data) {
      console.log("定位", data);
      /**
       * 当起点没有字符时就赋值起点
       * 当起点有字符时不定位（页面返回时会重新刷新,重新定位）
       */

      if (!this.$store.state.userBusRoute.start) {
        //定位起点名字太长，截取字符串
        let position = "";
        let positionText =
          data.addressComponent.province +
          data.addressComponent.city +
          data.addressComponent.district +
          data.addressComponent.township;
        let formattedAddress = data.formattedAddress;
        if (formattedAddress.indexOf(positionText) !== -1) {
          position = formattedAddress.replace(positionText, "");
        } else {
          position = data.formattedAddress;
        }
        this.$store.state.userBusRoute.start = position;

        this.$store.state.userBusRoute.startCity = data.addressComponent.city;
		console.log('startAdcode', data.addressComponent.adcode);
        this.$store.state.userBusRoute.startAdcode =
          data.addressComponent.adcode;

        this.$store.state.userBusRoute.startLat = data.position.lat;
        this.$store.state.userBusRoute.startLon = data.position.lng;

        this.$store.commit("UpdataStart", this.$store.state.userBusRoute);
      }
      this.$store.state.userBusRoute.receiveAddress = data.formattedAddress;
      this.$store.state.userBusRoute.receiveLon = data.position.lng;
      this.$store.state.userBusRoute.receiveLat = data.position.lat;
    },
    onError(error) {
      // if (error.message === "Geolocation permission denied.") {
      //   Dialog.alert({
      //     title:'温馨提示',
      //     message:'定位失败,请打开定位功能'
      //   });
      // }else{
      //     Dialog.alert({
      //     title:'温馨提示',
      //     message:`${error.message}`
      //   });
      // }
      this.inputPlaceholder = "请选择上车点";
      console.log(error);
    },
  },
};
</script>
<style lang="scss" scoped>
$bgf: #fff;
$df: #dfdfdf;
$borderD2: #dfdfdf;
$red: #fb503b;
$bgEb: #ebecf0;
$gray: #999999;
$EEE: #eeeeee;
.contianer {
  position: relative;
  padding-left: 18px;
  padding-right: 18px;
  margin-top: -150px;
  .cardContainer {
    background: $bgf;
    .flex {
      .van-col--22 {
        .border {
          border-top: 1px solid $df;
          height: 120px;
          display: flex;
          align-items: center;
          .van-cell {
            padding: 0;
          }
          .van-field {
            font-size: 34px;
          }
        }
        .borderArrow::after {
          content: "";
          border-top: 1px solid $borderD2;
          border-right: 1px solid $borderD2;
          width: 20px;
          height: 20px;
          transform: rotate(45deg);
          margin-right: 40px;
        }
      }
    }
  }
}
.containerTwo {
  margin-top: 30px;
  padding-left: 18px;
  padding-right: 18px;

  .cardContainer {
    padding-bottom: 40px;
    text-align: center;
    font-weight: 500;
    .carTitle {
      font-size: 40px;
      line-height: 140px;
      padding: 0;
      margin: 0;
    }
    .carMoney {
      color: red;
      font-size: 60px;
      margin: 0;
      padding-bottom: 30px;
      span {
        font-size: 40px;
      }
    }
    .danger {
      height: 130px;
      width: 100%;
      border-radius: 130px;
      background: $red;
      color: $bgf;
      letter-spacing: 1px;
      font-size: 40px;
    }
  }
}
.introduce {
  display: inline-block;
  // line-height: 70px;
  padding: 20px 24px 20px 30px;
  background: rgba($color: #000000, $alpha: 0.18);
  color: $bgf;
  font-size: 30px;

  border-radius: 50px 0 0 50px;
  position: absolute;
  right: 0;
  top: 30px;
  z-index: 9;
  display: flex;
  align-items: center;
}
.van-action-sheet__header {
  border-bottom: 1px solid $EEE;
}
.van-popup--bottom.van-popup--round {
  border-radius: 0;
}
.peopleContent {
  font-size: 30px;
  text-align: left;
  color: $gray;
  padding-bottom: 100px;
  .peopleTitle {
    line-height: 100px;
    padding-bottom: 40px;
    text-indent: 2.5%;
  }
  .peopleCountinContainer {
    text-align: center;
    .van-col {
      text-align: center;
    }
    .person {
      cursor: pointer;
      width: 80%;
      border: 1px solid transparent;
      display: inline-block;
      border-radius: 14px;
      line-height: 90px;
      background: $bgEb;
      font-size: 34px;
      margin: 0 auto 20px;
      &:hover {
        border: 1px solid red;
        background: $bgf;
      }
    }
  }
}
.loginContainer {
  z-index: 9;
}
#mapContainer {
  width: 0;
  height: 0;
}
.advertisingContainer {
  padding-left: 18px;
  padding-right: 18px;
  margin-top: 46px;
  .imgAdvertising2 {
    margin-top: 46px;
    margin-bottom: 46px;
  }
  .imgAdvertising2,
  .imgAdvertising1 {
    box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
  }
}
</style>

